import { create } from 'zustand';

interface UIState {
  drawerOpen: boolean;
  activityDialogOpen: boolean;
  errorsDialogOpen: boolean;
  contactDialogOpen: boolean;
  infoDialogOpen: boolean;
  configurationDialogOpen: boolean;
  idleDialogOpen: boolean;
  deleteDialogOpen: boolean;
  
  toggleDrawer: () => void;
  setActivityDialogOpen: (open: boolean) => void;
  setErrorsDialogOpen: (open: boolean) => void;
  setContactDialogOpen: (open: boolean) => void;
  setInfoDialogOpen: (open: boolean) => void;
  setConfigurationDialogOpen: (open: boolean) => void;
  setIdleDialogOpen: (open: boolean) => void;
  setDeleteDialogOpen: (open: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  drawerOpen: false,
  activityDialogOpen: false,
  errorsDialogOpen: false,
  contactDialogOpen: false,
  infoDialogOpen: false,
  configurationDialogOpen: false,
  idleDialogOpen: false,
  deleteDialogOpen: false,
  
  toggleDrawer: () => set((state) => ({ drawerOpen: !state.drawerOpen })),
  setActivityDialogOpen: (open) => set({ activityDialogOpen: open }),
  setErrorsDialogOpen: (open) => set({ errorsDialogOpen: open }),
  setContactDialogOpen: (open) => set({ contactDialogOpen: open }),
  setInfoDialogOpen: (open) => set({ infoDialogOpen: open }),
  setConfigurationDialogOpen: (open) => set({ configurationDialogOpen: open }),
  setIdleDialogOpen: (open) => set({ idleDialogOpen: open }),
  setDeleteDialogOpen: (open) => set({ deleteDialogOpen: open }),
}));
